import * as React from 'react'
import { Formik, Form, Field } from 'formik'
import { FormiikField } from '$views/components/Forms/FormiikField'
import { Button } from './Button'
import { validateFieldForm } from '$views/Login/Login.validators'

interface LoginFormValues {
  email: string
  password: string
}

interface Props {
  onSubmit: (loginCuidador: LoginFormValues) => void
  fluid?: boolean
  buttonLabel?: string
}

const getButtonLabel = (buttonLabel: string) => {
  if (buttonLabel) {
    return buttonLabel
  }

  return 'Iniciar sesión'
}

export const LoginForm: React.SFC<Props> = ({ onSubmit, buttonLabel, fluid }) => (
  <Formik
    initialValues={{ email: '', password: '' }}
    onSubmit={onSubmit}
    validate={validateFieldForm}
    render={() => (
      <>
        <Form>
          <Field
            name="email"
            label="Email: "
            component={FormiikField}
            type="email"
            placeholder="Email"
            primary="true"
            maxLength={100}
          />
          <Field
            name="password"
            label="Contraseña: "
            component={FormiikField}
            type="password"
            placeholder="Contraseña"
            primary="true"
          />
          <Button primary fluid={fluid} type="submit">
            {getButtonLabel(buttonLabel)}
          </Button>
        </Form>
      </>
    )}
  />
)



// WEBPACK FOOTER //
// ./src/views/components/LoginForm.tsx